import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Components/Header/Header";
import { LeftSettings } from "../LeftSettings";
import LeftMenu from "../../../Components/LeftMenu/LeftMenu";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";

import { TIMEZONE_OFFSETS } from "../../../Components/common/TimezoneOptions";

import { withRFSToken } from "../../../Services/axios.js";
import { CallApi } from "../../../Components/common/CommonFunctions.js";

const TimeZoneSettings = () => {
  const isMounted = useRef(false);

  // Saved timezone from backend
  const getTz = JSON.parse(localStorage.getItem("timeZone") || "null");
  // Keep this as a simple offset string so matching against TIMEZONE_OFFSETS is stable.
  const [savedTimezone, setSavedTimezone] = useState(getTz?.timezone_data?.value || "+01:00");

  // Temporary selection before confirmation
  const [pendingTimezone, setPendingTimezone] = useState(null);

  const [showConfirmation, setShowConfirmation] = useState(false);


  // Fetch timezone from backend
  const fetchTimeZone = () => {
    CallApi({
      endPoint: 'organization-timezone/get',
      method: 'get',
      onSuccess: (data) => {
        const resCode = data.data.response_code;
        if (resCode === 200) {
          const innerData = data.data.response_data;
          localStorage.setItem("timeZone", JSON.stringify(innerData))
          setSavedTimezone(innerData?.timezone_data?.value);
        }
      },
      onError: (msg) => toast.error(msg)
    });
  };

  const handleTimezoneChange = (selected) => {
    if (!selected) return;
    setPendingTimezone(selected);
    setShowConfirmation(true);
  };

  const handleConfirmChange = (confirm) => {
    if (confirm && pendingTimezone) {
      CallApi({
        endPoint: 'organization-timezone/save',
        payload: { timezone_data: pendingTimezone },
        onSuccess: (data) => {
          const resCode = data.data.response_code;
          if (resCode === 200) {
            const innerData = data.data.response_data;
            fetchTimeZone();
          }
        },
        onError: (msg) => toast.error(msg)
      });
    }
    setPendingTimezone(null);
    setShowConfirmation(false);
  };

  const shpTab = localStorage.getItem("FSTab");
  const SBack = localStorage.getItem("SettingsBack");

  return (
    <>
      {/* <Header
        logo_url={SBack ? SBack : `/ForwarderShipments/${shpTab ? shpTab : "ShipmentRecords"}`}
        sBackUrl={SBack ? SBack : `/ForwarderShipments/${shpTab ? shpTab : "ShipmentRecords"}`
        }
      />

      <div className="page-body-wrapper schedule">
        <LeftMenu />

        <div className="main-panel">
          <div className="row">
            <LeftSettings /> */}

      <div className="col-9 col-xxl-9 stting_right">
        <div className="settingbg_right">
          <h4>Timezone Settings</h4>
          <p>Select your preferred timezone.</p>
          <hr />

          <div className="d-flex align-items-center mt-3">
            <div className="me-3">
              <h4>Timezone</h4>
              <p>Please choose your local timezone.</p>
            </div>

            <div style={{ width: "250px" }}>
              <Select
                options={TIMEZONE_OFFSETS}
                value={
                  TIMEZONE_OFFSETS.find(
                    (opt) => opt.value === savedTimezone
                  ) || null
                }
                onChange={handleTimezoneChange}
                placeholder="Select Timezone"
                className="rfs_autoslct"
              />
            </div>
          </div>
        </div>
      </div>
      {/* </div>
        </div>
      </div> */}
      <Modal className="addfrom change_type" show={showConfirmation} onHide={() => handleConfirmChange(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Timezone Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to change your timezone to{" "}
          <b>{pendingTimezone?.label || pendingTimezone?.zone || pendingTimezone?.offset}</b>?
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={() => handleConfirmChange(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={() => handleConfirmChange(true)}>
              Yes, Change
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TimeZoneSettings;
